module.exports = "/_next/static/images/starweb-20e3c1196ef9c172c112a97128a67e88.png";